import { Show } from "solid-js";
import { coordinateOwnershipStats } from "../features/catalog/ownership";
import { styles } from "../styles";
import type { CoordItem } from "../types";

export function OwnershipSummary(props: { items: CoordItem[] }) {
  const stats = () => coordinateOwnershipStats(props.items);
  return (
    <Show when={stats().known} fallback={<span data-ownership-summary="true">-</span>}>
      <Show
        when={stats().complete}
        fallback={<span data-ownership-summary="true">{stats().owned}/{stats().total}</span>}
      >
        <span
          class={styles.completeOwnership}
          data-ownership-summary="true"
          data-complete="true"
          title="全パーツ所持"
          aria-label="全パーツ所持"
        >C</span>
      </Show>
    </Show>
  );
}
